import { HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';

export interface HttpOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  params?: HttpParams | { [param: string]: string | string[] };
}

export interface HttpOptionsWithText extends HttpOptions {
  responseType: 'text';
}

export interface HttpOptionsWithBlobResponse extends HttpOptions {
  responseType: 'blob';
  observe: 'response';
}

export interface HttpOptionsWithJsonEvents extends HttpOptions {
  responseType: 'json';
  observe: 'events';
  reportProgress?: boolean;
}

export interface ErrorWrapper extends HttpErrorResponse {
  processedMessage?: string;
}

export type ErrorPathType =
  | 'rowField'
  | 'row'
  | 'column'
  | 'grid'
  | 'field'
  | 'groupGridChildrenField'
  | 'groupGridParentField';

export interface ValidationError {
  errorMessage: string;
  errorPath: string;
  errorPathType: ErrorPathType;
  errorMessageLabelId?: string;
  errorPathRowId?: string;
}
